export const PRIVACY_POLICY_REVISION_NOTICE = {
  title: '개인정보 처리방침 개정 안내',
  announcementDate: '2026년 4월 27일',
  effectiveDate: '2026년 6월 1일',
  description: '개정된 개인정보 처리방침의 주요 변경사항을 확인하실 수 있습니다.',
};

const comparisonTitleClass = 'mb-2 font-[700] text-[#111827]';
const comparisonTextClass = 'space-y-1 text-[12px] leading-6 text-[#374151] md:text-[13px]';
const comparisonListClass = 'list-disc space-y-1 pl-4';
const nestedTableClass = 'mt-2 w-full min-w-[720px] border-collapse text-[11px] leading-5 md:text-[12px]';
const nestedThClass = 'border border-[#D9E0E7] bg-[#F3F7FA] px-2 py-2 text-left font-[700] text-[#1F2937]';
const nestedTdClass = 'border border-[#D9E0E7] px-2 py-2 align-top text-[#374151]';

export const PRIVACY_POLICY_REVISION_COMPARISON_ROWS = [
  {
    section: '개인정보 처리목적',
    previous: (
      <div className={comparisonTextClass}>
        <div className={comparisonTitleClass}>2. 개인정보의 수집 및 이용 목적</div>
        <p>회사는 고객의 개인정보를 다음 목적을 위해 활용합니다.</p>
        <ul className={comparisonListClass}>
          <li>문의사항 또는 불만 처리 등 민원처리, 고지사항 전달, 분쟁 조정을 위한 기록 보존</li>
          <li>이용자 맞춤형 서비스 제공</li>
          <li>신규 서비스 개발, 마케팅 및 광고 활용, 접속 빈도 파악, 서비스 이용 통계</li>
        </ul>
      </div>
    ),
    current: (
      <div className={comparisonTextClass}>
        <div className={comparisonTitleClass}>1. 개인정보의 처리 목적</div>
        <p>회사는 서비스 제공에 필요한 범위에서 개인정보를 처리하며, 목적 변경 시 필요한 조치를 이행합니다.</p>
        <ul className={comparisonListClass}>
          <li>이력서 등록, 조회, 수정, 삭제, 본인 확인 및 중복 이력서 방지</li>
          <li>구직 상담, 채용 연계, 면접·입사 등 채용 진행 안내</li>
          <li>장애 유형·근무조건 등을 고려한 직무 매칭 및 근로 지원 검토</li>
          <li>작성 이어하기, 후속 연락 관리, 간편문의 접수 및 민원 처리</li>
          <li>접속 기록 분석, 서비스 품질 개선, 보안 대응 및 부정 이용 방지</li>
        </ul>
      </div>
    ),
  },
  {
    section: '처리하는 개인정보 항목 및 보유기간',
    previous: (
      <div className={comparisonTextClass}>
        <div className={comparisonTitleClass}>3. 개인정보의 수집 항목</div>
        <ul className={comparisonListClass}>
          <li>기업명, 담당자명, 담당자직함, 기업 상시근로자 수, 기업 고용 중인 장애인 근로자 수</li>
          <li>이름, 휴대폰번호, 이메일, 주소, 장애 관련 정보, 작업능력, 자기소개서</li>
          <li>소속복지관, 비상연락처, 학력사항, 경력사항, 자격증, 포트폴리오</li>
          <li>서비스 이용기록, 접속 로그, 쿠키, 접속 IP 정보, 결제기록</li>
        </ul>
        <div className={comparisonTitleClass}>5. 개인정보의 보유 및 이용기간</div>
        <ul className={comparisonListClass}>
          <li>고객 문의 응대 및 과거 문의 연계 답변: 이름, 휴대전화번호, 이메일 1년</li>
          <li>소비자 불만 및 분쟁처리에 관한 기록: 3년</li>
        </ul>
      </div>
    ),
    current: (
      <div className={comparisonTextClass}>
        <div className={comparisonTitleClass}>1. 개인정보의 처리 목적, 수집 항목, 보유 및 이용기간</div>
        <div className="overflow-x-auto">
          <table className={nestedTableClass}>
            <thead>
              <tr>
                <th className={nestedThClass}>구분</th>
                <th className={nestedThClass}>수집 항목</th>
                <th className={nestedThClass}>보유 및 이용기간</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className={nestedTdClass}>이력서 작성 전 확인 및 작성 이어하기</td>
                <td className={nestedTdClass}>이름, 휴대폰번호, 동의 여부, 마지막 작성 단계, 최근 접속 시각</td>
                <td className={nestedTdClass}>이력서 삭제 요청 시까지</td>
              </tr>
              <tr>
                <td className={nestedTdClass}>이력서 등록 및 회원 관리</td>
                <td className={nestedTdClass}>이름, 생년월일, 성별, 비밀번호, 이메일, 휴대폰번호, 주소, 증명사진, 희망근무조건, 학력, 자기소개서</td>
                <td className={nestedTdClass}>이력서 삭제 요청 시까지</td>
              </tr>
              <tr>
                <td className={nestedTdClass}>민감정보 처리</td>
                <td className={nestedTdClass}>장애유형, 장애정도, 종합 장애 정도, 장애인증명서 파일, 기초수급 여부, 보훈 여부</td>
                <td className={nestedTdClass}>이력서 삭제 요청 시까지</td>
              </tr>
              <tr>
                <td className={nestedTdClass}>간편문의</td>
                <td className={nestedTdClass}>이름, 연락처, 이메일(선택), 문의유형, 문의내용, 처리기록</td>
                <td className={nestedTdClass}>문의 처리 완료 후 1년</td>
              </tr>
              <tr>
                <td className={nestedTdClass}>서비스 이용기록 및 보안</td>
                <td className={nestedTdClass}>접속 IP, 쿠키, 브라우저/기기 정보, 접속 로그, 페이지 이동 및 작성 이벤트</td>
                <td className={nestedTdClass}>접속 로그 3개월, 쿠키는 브라우저 설정 또는 만료 시까지</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    ),
  },
  {
    section: '개인정보의 파기 절차 및 방법',
    previous: (
      <div className={comparisonTextClass}>
        <div className={comparisonTitleClass}>9. 개인정보 파기 절차 및 방법</div>
        <p>회사는 수집한 개인정보의 이용목적이 달성된 후 보관기간 및 이용기간에 따라 해당 정보를 지체 없이 파기합니다.</p>
        <ul className={comparisonListClass}>
          <li>전자적 파일 형태: 기록을 재생할 수 없는 기술적 방법으로 삭제</li>
          <li>종이 출력물: 분쇄, 소각 또는 화학약품 처리</li>
        </ul>
      </div>
    ),
    current: (
      <div className={comparisonTextClass}>
        <div className={comparisonTitleClass}>7. 개인정보의 파기 절차 및 방법</div>
        <p>보유기간 경과 또는 처리 목적 달성 시 지체 없이 파기하며, 법령상 보존이 필요한 경우 분리 보관 후 파기합니다.</p>
        <ul className={comparisonListClass}>
          <li>파기 사유가 발생한 개인정보를 선정</li>
          <li>보존 필요성이 없는 개인정보는 지체 없이 파기</li>
          <li>전자파일은 복구 또는 재생이 어렵도록 삭제 또는 초기화</li>
          <li>종이 문서는 분쇄 또는 소각</li>
        </ul>
      </div>
    ),
  },
  {
    section: '개인정보의 제3자 제공',
    previous: (
      <div className={comparisonTextClass}>
        <div className={comparisonTitleClass}>6. 수집한 개인정보의 이용 및 제3자 제공</div>
        <p>회사는 이용자의 개인정보를 원칙적으로 외부에 제공하지 않습니다.</p>
        <ul className={comparisonListClass}>
          <li>이용자가 사전에 동의한 경우</li>
          <li>법령의 규정에 의거하거나 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우</li>
        </ul>
      </div>
    ),
    current: (
      <div className={comparisonTextClass}>
        <div className={comparisonTitleClass}>4. 개인정보의 제3자 제공</div>
        <p>회사는 정보주체의 개인정보를 정보 주체의 선택에 따른 채용 연계 제공을 제외하고는 원칙적으로 제3자에게 제공하지 않습니다.</p>
        <div className="overflow-x-auto">
          <table className={nestedTableClass}>
            <thead>
              <tr>
                <th className={nestedThClass}>제공받는 자</th>
                <th className={nestedThClass}>제공 목적</th>
                <th className={nestedThClass}>제공 항목</th>
                <th className={nestedThClass}>보유 및 이용기간</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className={nestedTdClass}>채용을 진행하는 구인기업</td>
                <td className={nestedTdClass}>채용 절차 진행, 면접 및 입사 검토</td>
                <td className={nestedTdClass}>이름, 연락처, 이력서 기재사항, 자기소개서, 장애 관련 지원 필요사항 중 채용 진행에 필요한 범위</td>
                <td className={nestedTdClass}>채용 절차 종료 시까지 또는 관련 법령에 따른 기간</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    ),
  },
  {
    section: '개인정보 처리업무의 위탁',
    previous: (
      <div className={comparisonTextClass}>
        <div className={comparisonTitleClass}>11. 개인정보 취급 업무의 위탁</div>
        <p>회사는 서비스 향상을 위해 개인정보가 필요한 경우 동의 등 법률상의 요건을 갖추어 외부에 수집·취급·관리 등을 위탁하여 처리할 수 있습니다.</p>
      </div>
    ),
    current: (
      <div className={comparisonTextClass}>
        <div className={comparisonTitleClass}>5. 개인정보 처리업무의 위탁</div>
        <div className="overflow-x-auto">
          <table className={nestedTableClass}>
            <thead>
              <tr>
                <th className={nestedThClass}>수탁자</th>
                <th className={nestedThClass}>위탁업무</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className={nestedTdClass}>(주)SU소프트</td>
                <td className={nestedTdClass}>국내 IDC 서버 운영 및 시스템 유지관리</td>
              </tr>
              <tr>
                <td className={nestedTdClass}>Google Cloud Platform (Firebase Storage)</td>
                <td className={nestedTdClass}>증명사진, 장애인증명서 등 첨부파일 저장</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    ),
  },
  {
    section: '개인정보의 국외 이전',
    previous: (
      <div className={comparisonTextClass}>
        <div className={comparisonTitleClass}>신설</div>
        <p>해당 조항 없음</p>
      </div>
    ),
    current: (
      <div className={comparisonTextClass}>
        <div className={comparisonTitleClass}>6. 개인정보의 국외 이전에 관한 사항</div>
        <p>회사는 서비스 이용 형태 분석 및 서비스 개선을 위하여 다음과 같이 개인정보를 국외로 이전할 수 있습니다.</p>
        <ul className={comparisonListClass}>
          <li>이전받는 자: Google LLC</li>
          <li>이전 국가: 미국</li>
          <li>이전 방법: 이용자가 웹사이트를 이용하는 시점에 네트워크를 통하여 전송</li>
        </ul>
      </div>
    ),
  },
  {
    section: '안전성 확보조치',
    previous: (
      <div className={comparisonTextClass}>
        <div className={comparisonTitleClass}>12. 개인정보보호를 위한 기술 및 관리적 대책</div>
        <ul className={comparisonListClass}>
          <li>개인정보 취급 직원 지정 및 수시 교육</li>
          <li>보안프로그램 설치, 갱신, 점검</li>
          <li>외부 접근이 통제된 구역에 시스템 설치 및 감시·차단</li>
        </ul>
      </div>
    ),
    current: (
      <div className={comparisonTextClass}>
        <div className={comparisonTitleClass}>9. 개인정보의 안전성 확보조치</div>
        <ul className={comparisonListClass}>
          <li>관리적 조치: 내부관리계획 수립·시행, 취급자 지정 및 최소화, 정기 교육 및 점검</li>
          <li>기술적 조치: 접근권한 관리, 접근통제시스템 운영, 암호화, 보안프로그램 설치 및 갱신</li>
          <li>물리적 조치: 전산실, 자료보관실 등 개인정보 보관장소 접근통제</li>
        </ul>
      </div>
    ),
  },
  {
    section: '자동 수집 장치',
    previous: (
      <div className={comparisonTextClass}>
        <div className={comparisonTitleClass}>13. 개인정보 자동수집장치의 설치·운영 및 거부</div>
        <p>회사는 인터넷서비스를 통하여 고객의 정보를 저장하고 수시로 찾아내는 쿠키를 설치·운용할 수 있습니다.</p>
        <p>고객은 웹 브라우저 설정을 통해 쿠키를 허용하거나 거부할 수 있습니다.</p>
      </div>
    ),
    current: (
      <div className={comparisonTextClass}>
        <div className={comparisonTitleClass}>10. 개인정보 자동 수집 장치의 설치·운영 및 거부</div>
        <p>회사는 서비스 품질 개선과 이용 현황 분석을 위해 쿠키와 유사 기술을 사용할 수 있습니다.</p>
        <p>또한 Google Analytics를 광고 목적이 아닌 서비스 운영 및 개선 목적 범위에서 이용합니다.</p>
        <ul className={comparisonListClass}>
          <li>쿠키: 작성 이어하기, 설정 유지, 서비스 이용 분석</li>
          <li>Google Analytics: 서비스 운영 및 개선 목적의 이용행태 분석</li>
        </ul>
      </div>
    ),
  },
  {
    section: '정보주체 권리 및 행사방법',
    previous: (
      <div className={comparisonTextClass}>
        <div className={comparisonTitleClass}>7. 정보주체의 권리·의무 및 행사방법</div>
        <p>정보주체는 회사가 처리하는 자신의 개인정보에 대한 열람, 정정·삭제, 처리정지를 요구할 수 있습니다.</p>
        <div className={comparisonTitleClass}>8. 동의철회 / 10. 회원 및 법정대리인의 권리</div>
        <p>개인정보의 수집, 이용, 제공에 대한 동의는 서면, 전화, E-mail 등을 통해 철회할 수 있습니다.</p>
        <p>회원 및 법정대리인은 개인정보관리책임자에게 열람, 수정, 탈퇴를 요청할 수 있습니다.</p>
      </div>
    ),
    current: (
      <div className={comparisonTextClass}>
        <div className={comparisonTitleClass}>8. 정보주체와 법정대리인의 권리·의무 및 행사방법</div>
        <p>정보주체는 회사에 대해 언제든지 개인정보 열람, 정정·삭제, 처리정지, 동의 철회 등을 요구할 수 있습니다.</p>
        <p>권리 행사는 전자우편, 전화, 서면 등을 통해 요청할 수 있으며 회사는 지체 없이 확인 후 처리합니다.</p>
      </div>
    ),
  },
  {
    section: '보호책임자 및 담당부서',
    previous: (
      <div className={comparisonTextClass}>
        <div className={comparisonTitleClass}>15. 서비스의 개인정보 보호책임자에 관한 사항</div>
        <ul className={comparisonListClass}>
          <li>성명: 유진섭</li>
          <li>부서: 전략사업팀</li>
          <li>이메일: jsyoo@vdream.co.kr</li>
          <li>전화번호: 1644.8619</li>
        </ul>
      </div>
    ),
    current: (
      <div className={comparisonTextClass}>
        <div className={comparisonTitleClass}>11. 개인정보 보호책임자 및 개인정보 열람청구 담당부서</div>
        <ul className={comparisonListClass}>
          <li>개인정보 보호책임자: 유진섭 / 기업부설연구소 / 소장 / security@vdream.co.kr</li>
          <li>열람청구 및 고객상담 담당부서: 장애인인재경영팀 / 1644-8619 / job@vdream.co.kr</li>
        </ul>
      </div>
    ),
  },
  {
    section: '권익침해 구제방법',
    previous: (
      <div className={comparisonTextClass}>
        <div className={comparisonTitleClass}>15. 서비스의 개인정보 보호책임자에 관한 사항</div>
        <ul className={comparisonListClass}>
          <li>개인분쟁 조정위원회: www.1336.or.kr / 1336</li>
          <li>정보보호마크인증 위원회: www.eprivacy.or.kr / 02-580-0533~4</li>
          <li>대검찰청 인터넷 범죄수사센터: www.spo.go.kr / 02-3480-3600</li>
          <li>경찰청 사이버테러 대응센터: www.ctrc.go.kr / 02-392-0330</li>
        </ul>
      </div>
    ),
    current: (
      <div className={comparisonTextClass}>
        <div className={comparisonTitleClass}>12. 정보주체의 권익침해에 대한 구제방법</div>
        <ul className={comparisonListClass}>
          <li>개인정보 분쟁조정위원회: 1833-6972 / www.kopico.go.kr</li>
          <li>개인정보침해신고센터: 118 / privacy.kisa.or.kr</li>
          <li>대검찰청: 1301 / www.spo.go.kr</li>
          <li>경찰청: 182 / ecrm.police.go.kr</li>
        </ul>
      </div>
    ),
  },
  {
    section: '처리방침 변경',
    previous: (
      <div className={comparisonTextClass}>
        <div className={comparisonTitleClass}>16. 개인정보취급방침의 개정과 그 공지</div>
        <p>현 개인정보처리방침 내용 추가, 삭제 및 수정이 있을 시에는 개정 최소 7일 전부터 홈페이지의 공지사항을 통해 고지합니다.</p>
        <p>개인정보의 수집 및 활용, 제3자 제공 등 이용자 권리의 중요한 변경이 있을 경우에는 최소 30일 전에 고지합니다.</p>
        <ul className={comparisonListClass}>
          <li>공고일자: 2020년 1월 1일</li>
          <li>시행일자: 2020년 1월 1일</li>
        </ul>
      </div>
    ),
    current: (
      <div className={comparisonTextClass}>
        <div className={comparisonTitleClass}>13. 개인정보 처리방침의 변경</div>
        <p>회사는 법령, 서비스 내용 또는 개인정보 처리 현황의 변경이 있는 경우 본 개인정보 처리방침을 개정할 수 있습니다.</p>
        <p>중요한 변경이 있는 경우에는 적용일자 전 합리적인 기간 동안 별도 공지, 팝업, 전자우편 또는 그에 준하는 방법으로 안내할 수 있습니다.</p>
      </div>
    ),
  },
];
